import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4800Model } from '../kymw4800.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 媒体一覧取得サービス
 * @export GetMediumListService
 * @class GetMediumListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetMediumListService extends PlessJsonResponderSub<any> {
  private model: KYMW4800Model;
  private successFunc: Function;
  private exceptionErrorFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetMediumListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({parameter: {}});
  }

  /**
   * API呼び出し
   *
   * @param {KYMW4800Model} model モデルクラス
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetMediumListService
   */
  execute(model: KYMW4800Model, successFunc: Function = null, exceptionErrorFunc: Function = null): void {
    this.model = model;
    this.successFunc = successFunc;
    this.exceptionErrorFunc = exceptionErrorFunc;
    this.send('KYMW48getMediumList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetMediumListService
   */
  success(data: any): void {
    if (data !== null) {
      this.model.mediumList = data.map((_) => {
        return {
          mediumType: _.MediumType,
          mediumName: _.MediumName,
        }
      });
    }
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof GetMediumListService
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
